<template>
    <BaseModal
        :show="show"
        title="Solicitar liquidación"
        subtitle="Puedes agregar observaciones opcionales para la revisión."
        :show-message="false"
        confirm-text="Solicitar liquidación"
        confirm-variant="primary"
        max-width="xl"
        :confirm-disabled="disabled"
        @close="handleClose"
        @confirm="submit"
    >
        <ValidationObserver ref="observer" tag="div">
            <ValidationProvider name="observaciones" rules="max:1000" mode="passive" v-slot="{ errors }">
                <div class="tw:flex tw:flex-col tw:gap-2">
                    <label class="tw:text-sm tw:font-medium tw:text-gray-700" for="send-for-review-observaciones">
                        Observaciones (opcional)
                    </label>
                    <textarea
                        id="send-for-review-observaciones"
                        v-model="localObservaciones"
                        class="tw:min-h-[132px] tw:w-full tw:rounded tw:border tw:px-3 tw:py-2 tw:text-sm tw:text-gray-700 tw:focus:outline-none"
                        :class="errors[0] ? 'tw:border-red-500 tw:bg-red-50/50' : 'tw:border-slate-300 tw:bg-white tw:focus:border-blue-400'"
                        rows="5"
                        maxlength="1000"
                        placeholder="Agrega contexto para la revisión de la liquidación"
                        :disabled="disabled"
                    ></textarea>
                    <div class="tw:flex tw:justify-between tw:text-xs tw:text-gray-500">
                        <span>Máximo 1000 caracteres</span>
                        <span>{{ localObservaciones.length }}/1000</span>
                    </div>
                    <span v-if="errors[0]" class="tw:text-xs tw:font-medium tw:text-red-600">
                        {{ errors[0] }}
                    </span>
                </div>
            </ValidationProvider>
        </ValidationObserver>
    </BaseModal>
</template>

<script setup>
    import { ref, watch } from 'vue'
    import BaseModal from '@/modules/admin/ui/BaseModal.vue'

    const props = defineProps({
        show: {
            type: Boolean,
            default: false
        },
        observaciones: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    })

    const emit = defineEmits(['close', 'confirm'])

    const observer = ref(null)
    const localObservaciones = ref('')

    watch(() => props.show, isOpen => {
        if (!isOpen) {
            return
        }

        localObservaciones.value = props.observaciones || ''
        observer.value?.reset()
    }, { immediate: true })

    watch(() => props.observaciones, observaciones => {
        if (!props.show) {
            localObservaciones.value = observaciones || ''
        }
    })

    function handleClose() {
        emit('close')
    }

    async function submit() {
        const isValid = await observer.value?.validate()

        if (isValid === false) {
            return
        }

        const observaciones = localObservaciones.value.trim()

        emit('confirm', observaciones || null)
    }
</script>
